import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, comboIncludes, ctaLabel, price, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-cream relative border-y border-silver-light" data-id="element-178" data-mp="1j8p1xdh65dik">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-179" data-mp="1nasp2zd7a6jo">
        <div className="text-center mb-10" data-id="element-180" data-mp="1naaknfgdwm0o">
          <h2 className="text-3xl md:text-5xl font-display font-extrabold mb-3 text-ink" data-id="element-181" data-mp="1s9dgc9ah5fvz">
            Your complete offer today
          </h2>
          <p className="text-graphite text-sm md:text-base" data-id="element-182" data-mp="1x99kc8j697bj">
            7 complete volumes + 150 ready-to-coach sessions + 5 bonus guides.
          </p>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-cream-light border-2 border-ink rounded-3xl p-1 relative shadow-[0_20px_50px_-34px_rgba(21,23,26,0.45)]" data-id="element-183" data-mp="2v8przunn6h9">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-184" data-mp="1hnv9glydzz7q">
            <Sparkles size={14} aria-hidden="true" data-id="element-185" data-mp="17ppaod7vn973" /> Complete System
          </div>
          <div className="bg-paper rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-186" data-mp="25er9g6czy0q2">
            <h3 className="text-2xl md:text-3xl font-display font-extrabold text-ink mb-3" data-id="element-187" data-mp="20hr2zuc8ivyf">
              Boxing Coach Ready
            </h3>
            <p className="text-base text-graphite mb-6" data-id="element-188" data-mp="1vj7f3oe2za3f">
              The complete professional boxing coaching system.
            </p>
            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-cream-light border border-silver-light rounded-xl p-4" data-id="element-189" data-mp="k2g2stj5kgot">
              {comboIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-graphite" data-id="element-190" data-mp="hhrqwryiknki">
                  <Check size={16} className="text-accent shrink-0 mt-0.5" aria-hidden="true" data-id="element-191" data-mp="hfx4183omlds" />
                  <span data-id="element-192" data-mp="mei85im21p7i">{item}</span>
                </li>)}
            </ul>
            <div className="mb-6" data-id="element-193" data-mp="7log6xpljgly">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-194" data-mp="ci5fmo28xhec">
                <span className="text-2xl md:text-3xl text-ink font-display font-bold" data-id="element-195" data-mp="3uwo1xxb78mva">TODAY:</span>
                <span className="text-4xl md:text-5xl font-display font-bold text-accent" data-id="element-196" data-mp="3i0bcmscmz4e">
                  {price.today}
                </span>
              </div>
            </div>
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-197" data-mp="3kwnh26xolyoz">
              {ctaLabel}
            </Button>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-graphite-light mb-4" data-id="element-198" data-mp="3fy3x2c2newz9">
              <span className="flex items-center gap-1.5" data-id="element-199" data-mp="2xbmu2bxv13ud">
                <Lock size={12} className="text-accent" aria-hidden="true" data-id="element-200" data-mp="2scju35wqlnt9" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-201" data-mp="36cuhu02r2ma7">
                <Zap size={12} className="text-accent" aria-hidden="true" data-id="element-202" data-mp="31colw7pg6dmb" /> Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-203" data-mp="3g9phwneo8uql">
                <Shield size={12} className="text-accent" aria-hidden="true" data-id="element-204" data-mp="3g84ncxscxbsq" /> 7-day guarantee
              </span>
            </div>
            <div className="bg-cream border border-silver-light rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-205" data-mp="3p29fdkj88t9u">
              <Globe className="text-accent shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-206" data-mp="3l1qphw0w9xaa" />
              <p className="text-[11px] text-graphite-light leading-snug" data-id="element-207" data-mp="2u9ok08fc519">
                Pay in your local currency according to the options available through your payment
                provider.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}